import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { STATS } from "@/data/site";
import { Reveal } from "@/components/Reveal";

const CountUp = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setN(value);
      return;
    }
    const start = performance.now();
    const dur = 1400;
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref} className="font-sora text-4xl sm:text-5xl font-extrabold gradient-text">
      {n}
      {suffix}
    </span>
  );
};

const Stats = () => (
  <section id="stats" data-testid="stats-strip" className="relative border-y border-white/10 bg-[#0D131B]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-2 lg:grid-cols-4 gap-10">
      {STATS.map((s, i) => (
        <Reveal key={s.testid} delay={i * 0.08} className="text-center lg:text-left">
          <div data-testid={s.testid}>
            <CountUp value={s.value} suffix={s.suffix} />
            <p className="text-sm text-[#F5F5F0]/60 mt-2 tracking-wide">{s.label}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Stats;
